import { Checkbox, CircularProgress, Container } from "@mui/material";
import PageHeader from "components/Shared/PageHeader";
import Section from "./comps/Section";
import ContainedTabs from "components/Tabs/Tabs3";
import useFactor from "./data";
import BasicSelect from "components/BasicInputs/BasicSelect";
import { SeeMore } from "components/Shared/report/SeeMore";
import Table from "components/Table2";
import RenderInput from "../BasicInputs/RenderInput";
import OptionalInput from "./comps/OptionalInput";
import HashtagIcon from "assets/icons/Hashtag";
import BasicButton from "components/BasicInputs/BasicButton";
import PlusIcon from "assets/icons/PlusIcon";
// @ts-ignore
import BarcodeReader from "react-barcode-reader";
import warehouseImage from "assets/svg/inventory.svg";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import CheckIcon from "assets/icons/CheckIcon";
import { appSetAlert, appSetModal, setConfirm } from "store/actions/appAction";
import { apiGetWarehouses } from "api/warehouseApi";
import { apiGetPriceItem } from "../../api/productApi";
import { formatPrice } from "helpers";
import Switch from "pages/business/Subscription/Switch";
import TransactionCard from "components/Transaction2/comps/DestinationCard";
import shortid from "shortid";
import { useEffect, useState } from "react";
import Icon from "components/Shared/atoms/Icon";
import PersonLogo from "assets/svg/IconLogoPerson2.svg";
import Tabs from "components/Tabs";
import FolderIcon from "assets/icons/FolderIcon";
import LocationIcon from "assets/icons/LocationIcon";
import SellerPercentIcon from "assets/icons/LocationIcon copy";
import Notes from "./comps/Notes";
import { useAppDispatch } from "store/store";

interface FactorFormProps {
  onChange?: (data: FactorMainData) => void;
  onSuccess?: () => void;
  noHeader?: boolean;
}

export default function FactorForm(props: FactorFormProps) {
  const dispatch = useAppDispatch();
  const factorData = useFactor();
  const [isFooterSmaller, setIsFooterSmaller] = useState(false);

  const { tabs, table, pricePlans, currencies, state, setState, person, data, active } = factorData;
  const { project, branch, seller, taxConditions, handleCostsChange, handleAddRow } = factorData;
  const { totalPrice, tablePrice, inputsOnTabs } = factorData;
  const { handleSubmit, handleBarcodeScan, isEdit, store } = factorData;
  const { token, business } = store.businessReducer.business;
  let inputs = factorData.inputs;
  let activeInputs = inputsOnTabs[active.tab];
  inputs = activeInputs.flatMap((x) => inputs.find((y) => y.id === x) || []);

  const Input = (input: FormInput, i: number) => (
    <div className="flex w-full py-4 md:p-4 md:w-auto">
      <div className="w-full md:w-96">
        <RenderInput {...input} />
      </div>
    </div>
  );

  useEffect(() => {
    props.onChange && props.onChange(data);
  }, [data]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    const scrollThreshold = 0.91; // Adjust this value as needed
    const scrollPosition = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const shouldFooterBeSmaller = scrollPosition > documentHeight * scrollThreshold - windowHeight;
    setIsFooterSmaller(shouldFooterBeSmaller);
  };

  // @ts-ignore
  return (
    <Container maxWidth="xl" className="md:pr-12 md:pl-12 ">
      <BarcodeReader
        onError={(err: any, a: any, b: any) => console.log(err, a, b)}
        onScan={(barcode: any) => {
          handleBarcodeScan(barcode);
        }}
      />

      {!props.noHeader && (
        <div className="mt-5 mb-10">
          <PageHeader heading="ثبت فاکتور" backBtnTitle="بازگشت به لیست فاکتورها" />
        </div>
      )}

      <div className="relative flex flex-col gap-6 mb-20">
        {/* Section one */}
        <Section
          header={
            <div className="flex flex-wrap items-center gap-4">
              <span className="text-base font-medium">نوع فاکتور</span>
              <ContainedTabs {...tabs} key={active.tab} />
              {factorData.type !== "waste" && (
                <div>
                  <Checkbox
                    checked={active.returned}
                    onChange={() => {
                      const returned = !active.returned;
                      const type = factorData.type;
                      const typeNames: any = { sale: "فروش", buy: "خرید" };

                      let title = factorData.data.title;
                      const str1 = `فاکتور ${typeNames[type]}`;
                      if (returned) title = title?.replace(str1, `${str1} برگشتی`);
                      else title = title?.replace(`${str1} برگشتی`, str1);

                      factorData.setActive((x) => ({ ...x, returned }));
                      factorData.setData((x) => ({ ...x, title }));
                    }}
                  />
                  <span>فاکتور برگشتی</span>
                </div>
              )}
            </div>
          }
        >
          <div className="flex flex-wrap justify-center md:justify-between ">
            <div className="w-full md:w-auto">
              {inputs.filter((x, i) => x.required && i % 2 === 0).map(Input)}
            </div>
            <div className="w-full md:w-auto">
              {inputs.filter((x, i) => x.required && i % 2 !== 0).map(Input)}
            </div>
          </div>
          <SeeMore
            style={{ padding: 0 }}
            scrollable={false}
            btnStyle={{ color: "#1062D0", fontWeight: "bold", marginRight: 16 }}
            iconColor="#1062D0"
            expandLabel="فیلد های بیشتر"
            collapseLabel="فیلد های کمتر"
            contents={[
              <div key={"key"} className="flex flex-wrap justify-center md:justify-between">
                <div className="w-full md:w-auto">
                  {inputs.filter((x, i) => !x.required && i % 2 === 0).map(Input)}
                </div>
                <div className="w-full md:w-auto">
                  {inputs.filter((x, i) => !x.required && i % 2 !== 0).map(Input)}
                </div>
              </div>
            ]}
          />
        </Section>

        {/* Section two */}
        <Section
          header={
            <div className="flex flex-wrap items-center justify-between w-full gap-4 ">
              <div className="text-base font-medium">افزودن کالا/خدمات</div>
              <div className="flex flex-wrap gap-x-20 gap-y-4">
                <div className="flex flex-wrap items-center gap-8 md:flex-nowrap">
                  <div className="flex items-center gap-2">
                    <Switch
                      size={2}
                      active={factorData.state.settings.warehouse.active}
                      onChange={(a) => {
                        if (!a) {
                          factorData.handleWarehouseChange(undefined);
                        }
                        factorData.setState((x) => ({
                          ...x,
                          settings: { ...x.settings, warehouse: { ...x.settings.warehouse, active: a } }
                        }));
                      }}
                    />
                    <BasicSelect
                      defaultValue={data.WarehouseId}
                      options={factorData.warehouses.map((x) => ({
                        ...x,
                        ind: x.accountingCode,
                        icon: warehouseImage,
                        hideImageOnBtn: true,
                        dsc: x.address
                      }))}
                      name="wwwwwwwwwwwww"
                      onChange={factorData.handleWarehouseChange}
                      preferences={{ button: 2 }}
                      onClear={() => factorData.setData((x) => ({ ...x, WarehouseId: undefined }))}
                      menuStyle={{ minWidth: factorData.isMobile ? 360 : 400 }}
                      containerStyle={{ width: 250 }}
                      withSearch
                      placeholder="انتخاب انبار حواله"
                      closeOnFooterClick
                      footer={
                        <BasicButton
                          onClick={() => {
                            factorData.dispatch(
                              appSetModal({
                                component: "inventory",
                                title: "افزودن انبار",
                                closeButton: true,
                                onFinish: (token: any, res: any) => {
                                  if (res) {
                                    dispatch(
                                      apiGetWarehouses(token, () => {
                                        factorData.handleWarehouseChange(res.id);
                                      })
                                    );
                                  }
                                }
                              })
                            );
                          }}
                        >
                          <PlusIcon scale={0.7} /> <span>افزودن انبار</span>
                        </BasicButton>
                      }
                      withRefresh
                    // refreshList={() => dispatch(apiGetWarehouses(token))}
                    />
                  </div>
                  <div className="flex items-center gap-4">
                    {/* <span className="w-full whitespace-nowrap">لیست قیمت</span> */}
                    <BasicSelect
                      defaultValue={state?.pricePlan?.value || pricePlans[0]?.value} // change this
                      options={pricePlans}
                      onChange={(val, option) => {
                        let list = factorData.rows.map(x => { if (x.productId) return { productId: x.productId, pricePlanId: val } })
                        list = list.filter(r => r !== undefined)
                        if (list.length) {
                          dispatch(apiGetPriceItem(token, list, (res: any) => {
                            const pros = res.data.products
                            const rows = factorData.rows.map(row => {
                              const priceProduct = pros.find((x: any) => x.productId === row.productId)
                              if (typeof priceProduct !== "undefined") {


                                row['price'] = priceProduct.price
                                row["constantPrice"] = priceProduct.price
                                row.product.pricePlanPrice = priceProduct.price
                              }
                              return row
                            })
                            return setState((x: any) => ({ ...x, rows: [...rows], pricePlan: option }));
                          }))
                        } else {

                          return setState((x: any) => ({ ...x, pricePlan: option }));
                        }
                      }}
                      preferences={{ button: 2 }}
                      menuStyle={{ minWidth: 120 }}
                      withRefresh
                      //refreshList={() => dispatch(apiGetPricePlans(token))}
                      noVirtual
                    />
                  </div>
                  <div className="flex items-center gap-4">
                    {/* <span className="w-full whitespace-nowrap">واحد پول</span> */}
                    <BasicSelect
                      defaultValue={state?.currency?.value || currencies[0]?.value}
                      options={currencies}
                      onChange={(val, option) => setState((x: any) => ({ ...x, currency: option }))}
                      preferences={{ button: 2 }}
                      menuStyle={{ minWidth: 120 }}
                      noVirtual
                    />
                  </div>
                </div>
                {/* <div className="flex items-center gap-2 ml-10">
                  <Switch
                    size={2}
                    active={state.settings[1].active}
                    onChange={(active) =>
                      setState((x) => ({
                        ...x,
                        settings: x.settings.map((s, i) => {
                          if (i === 1) return { ...s, active };
                          return s;
                        }),
                      }))
                    }
                  />
                  <span className="w-full whitespace-nowrap">حواله انبار</span>
                </div> */}
              </div>
            </div>
          }
        >
          <Table {...table} />
        </Section>

        {/* Section three */}
        <div className="flex flex-wrap p-6 bg-white rounded-md gap-x-24 md:flex-nowrap ">
          <div className="w-full max-w-[480px]">
            {/* Title Section */}
            <div className="mb-6 bg-light-4 rounded-md min-h-[280px] border border-slate-200">
              {/* Header */}
              {isEdit || state.notes?.length || active.summaryTab === 1 ? (
                <Tabs
                  tabs={[{ label: "خلاصه فاکتور" }, { label: "یادداشت ها" }]}
                  activeTab={active.summaryTab}
                  onChange={(val) => factorData.setActive((x) => ({ ...x, summaryTab: val }))}
                  style={{ height: 56 }}
                />
              ) : (
                <div className="flex items-center justify-between px-6 py-2 border-b border-slate-200 h-14">
                  <span className="text-base text-dark-3">خلاصه فاکتور</span>
                  <BasicButton
                    onClick={() => {
                      factorData.setActive((x) => ({ ...x, summaryTab: 1 }));
                    }}
                  >
                    <PlusIcon scale={0.6} color="#1062D0" />
                    <span>افزودن یادداشت</span>
                  </BasicButton>
                </div>
              )}
              <div
                className="flex-col gap-6 py-4 px-6 min-h-[270px]"
                style={{ display: active.summaryTab !== 0 ? "none" : "flex" }}
              >
                {/* Factor title */}
                {data.title && (
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <span className="text-lg text-dark-1">{data.title}</span>
                      <HashtagIcon color="#576271" style={{ transform: "scale(1.2)" }} />
                      {data.accountingCode ? (
                        <span className="text-xl text-dark-1">{data.accountingCode}</span>
                      ) : (
                        <span className="text-lg text-dark-1">{"اتوماتیک"}</span>
                      )}
                    </div>
                  </div>
                )}

                {/* Person Name */}
                <div className="flex items-start justify-between">
                  {person?.nickName && (
                    <div className="flex items-center gap-2">
                      <Icon url={person?.avatar || PersonLogo} rounded />
                      <div className="text-base text-dark-2">{person?.nickName}</div>
                    </div>
                  )}
                </div>

                {/* Project title */}
                {project && (
                  <div className="flex flex-wrap items-center justify-between">
                    <div className="flex items-center gap-2">
                      <FolderIcon />
                      <span>پروژه</span>
                    </div>
                    <span>{project.title}</span>
                  </div>
                )}

                {/* Branch title */}
                {branch && (
                  <div className="flex flex-wrap items-center justify-between">
                    <div className="flex items-center gap-2">
                      <LocationIcon />
                      <span>شعبه</span>
                    </div>
                    <span>{branch.title}</span>
                  </div>
                )}

                {/* Seller title */}
                {seller && (
                  <>
                    <div className="flex flex-wrap items-center justify-between">
                      <div className="flex items-center gap-2">
                        <SellerPercentIcon />
                        <span>فروشنده</span>
                      </div>
                      <div className="flex items-center gap-2">
                        {!!factorData.sellerCommission && (
                          <div className="flex items-center">
                            <span>{"("}</span>
                            <span>{<PlusIcon color="green" scale={0.5} />}</span>
                            <span>{formatPrice(factorData.sellerCommission)}</span>
                            <span className="px-1 text-xs text-dark-3">{state.currency.en_title}</span>
                            <span>{")"}</span>
                          </div>
                        )}
                        <span className="flex justify-center">{seller.nickName}</span>
                      </div>
                    </div>
                  </>
                )}
                {/* Notification Section */}
                {business.subscription &&
                  ![7, 10, 13, 17].includes(business.subscription.id) &&
                  factorData.type === "sale" &&
                  !isEdit && (
                    <div
                      className="flex items-center self-end w-full gap-2 pt-6 pb-2 mt-auto border-t border-slate-300">
                      <Switch
                        active={state.notification}
                        onChange={(active) => setState((x) => ({ ...x, notification: active }))}
                        size={2}
                      />
                      <span>ارسال پیامک برای گیرنده فاکتور</span>
                    </div>
                  )}
              </div>

              <div
                className="max-h-[480px] min-h-[270px] overflow-y-auto relative"
                style={{ display: active.summaryTab !== 1 ? "none" : "flex" }}
              >
                <Notes
                  detailId={factorData.factor.id}
                  detailType={"Factor"}
                  onChange={(notes) => setState((x) => ({ ...x, notes }))}
                />
              </div>
            </div>

            {/* description */}
            <div className="mt-6">
              <BasicTextInput
                textArea
                val={data.description}
                onChange={(val) => factorData.setData((x) => ({ ...x, description: val }))}
                label="توضیحات فاکتور"
              />
              <div className="h-8" />
            </div>
          </div>
          <div className="flex justify-end w-full">
            <div className="w-full max-w-[480px]">
              {/* Price section */}
              <div className="flex flex-col gap-4 mb-6 bg-[#F5F9FC] p-4 rounded-md min-h-[280px]">
                {/* Sum */}
                <div className="flex items-center justify-between">
                  <span className="text-base font-bold">مجموع</span>
                  <div className="flex items-center gap-2 px-4">
                    <span className="text-base">{Intl.NumberFormat().format(tablePrice)}</span>
                    <span className="text-sm text-dark-3">{state?.currency?.en_title}</span>
                  </div>
                </div>

                {state.costs.map((cost, index) => {
                  if (factorData.DisableTax && cost.key === "tax") return <></>;
                  let conditions = taxConditions;
                  if (cost.allowedCond) {
                    conditions = taxConditions.filter((x, i) => cost.allowedCond?.includes(i));
                  }
                  const totalCosts: any = {
                    tax: factorData.totalTaxPrice,
                    discount: factorData.totalDiscountPrice
                  };
                  return (
                    <div key={index} className="flex items-center justify-between gap-2">
                      <OptionalInput
                        {...cost}
                        input={
                          cost.input || {
                            name: cost.title,
                            type: "cond",
                            conditions,
                            inputProps: {
                              inputStyle: {
                                textAlign: cost.type === "currency" ? "start" : "center",
                                fontSize: cost.type === "currency" ? 16 : 14
                              }
                            }
                          }
                        }
                        onChange={({ val, active }) =>{
                          handleCostsChange({ val, active, cost })}

                        } 
                        val={{ val: cost.value, cond: conditions.find((x) => x.value === cost.type) }}
                      />
                      {cost.type === "percent" && cost.key && (
                        <div className="flex gap-2 items-center px-4 min-w-[150px] justify-end">
                          <span className="text-base">
                            {Intl.NumberFormat().format(totalCosts[cost.key])}
                          </span>
                          <span className="text-sm text-dark-3">{state?.currency?.en_title}</span>
                        </div>
                      )}
                    </div>
                  );
                })}
                <div className="flex flex-col gap-2"></div>
                <div className="flex items-center justify-between py-4 rounded-md">
                  <span className="text-lg font-bold">مبلغ قابل پرداخت</span>
                  <div className="flex items-center gap-2 px-4">
                    <span className="text-lg font-bold">{Intl.NumberFormat().format(totalPrice)}</span>
                    <span className="text-sm text-dark-3">{state?.currency?.en_title}</span>
                  </div>
                </div>
              </div>

              {/* Transaction Section */}
              {
                !isEdit || state.transactionsBelong?.length === 0 ? (
                  <>
                    <div className="flex items-center gap-2 mb-6">
                      <Switch
                        active={state.canPay || !!state.transactions?.length}
                        onChange={(active) => setState((x) => {
                          if (active) {
                            return { ...x, canPay: active }

                          } else {
                            return { ...x, transactions: [], canPay: active }
                          }
                        }
                        )}
                        size={2}
                      />
                      <span>پرداخت فاکتور</span>
                    </div>
                    {["sale", "buy"].includes(factorData.type) &&
                      (state.canPay || !!state.transactions?.length) && (
                        <div className="flex flex-col gap-4 mb-4">
                          <div className="flex items-center justify-between">
                            <span className="text-base font-bold">پرداخت فاکتور</span>
                            <div className="flex items-center">
                              <span>مجموع :</span>
                              <div className="flex items-center gap-2 px-4">
                                <span
                                  className={`text-sm font-bold ${factorData.transactionsPrice !== totalPrice ? "text-red-500" : "text-green-500"
                                    }`}
                                >
                                  {Intl.NumberFormat().format(factorData.transactionsPrice)}
                                </span>
                                <span className="text-xs text-dark-3">{state?.currency?.en_title}</span>
                              </div>
                            </div>
                          </div>
                          {state.transactions.map((x, i, a) => {
                            return (
                              <TransactionCard
                                key={i}
                                index={i}
                                transactionsPrice={factorData.transactionsPrice}
                                currency={state.currency}
                                transactionType={active.tab === 0 ? "receive" : "payment"}
                                defPrice={x.data?.price || totalPrice}
                                totalPrice={totalPrice}
                                data={x.data}
                                type={x.type}
                                onChange={(data) => {
                                  setState((x) => ({
                                    ...x,
                                    transactions: x.transactions.map((t, ti) => {


                                      return i === ti ? { ...data, edit: true } : t
                                    }
                                    )
                                  }));
                                }}
                                onDelete={(index) => {
                                  const del: any = () => {
                                    setState((x) => ({
                                      ...x,
                                      transactions: x.transactions.filter((t, ti) => ti !== index)
                                    }));
                                  };
                                  if (x.done) {
                                    dispatch(setConfirm("آیا مطمئن هستید ؟", del));
                                  } else del();
                                }}
                                edit={x.edit}
                                onChangeEdit={(edit) => {
                                  setState((x) => ({
                                    ...x,
                                    transactions: x.transactions.map((t, ti) => (i === ti ? { ...t, edit } : t))
                                  }));
                                }}
                              />
                            );
                          })}
                          <div
                            onClick={() => {
                              if (state.transactions.find((x) => !x?.done)) {
                                dispatch(appSetAlert("ابتدا باید تراکنش موجود را تکمیل کنید", "warning"));
                              } else {
                                setState((x) => ({
                                  ...x,
                                  transactions: [
                                    ...x.transactions,
                                    { data: { price: totalPrice - factorData.transactionsPrice }, ind: shortid.generate(), edit: true, done: false }
                                  ]
                                }));
                              }
                            }}
                            className="p-3 rounded-md hover:cursor-pointer hover:bg-blue-50"
                            style={{
                              backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%231062D0FF' strokeWidth='3' stroke-dasharray='12%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`
                            }}
                          >
                            <div className="flex items-center gap-1">
                              <PlusIcon scale={0.5} />
                              {factorData.type === "sale" ? <span>افزودن دریافت</span> : <span>افزودن پرداخت</span>}
                            </div>
                          </div>
                        </div>
                      )}
                  </>
                ) : state.transactionsBelong.map((item, index) => (
                  <>
                    <div key={index} style={{ borderRadius: '8px', padding: "20px", margin: "0 auto", background: "#F5F9FC" }} className="flex items-center justify-between gap-8">
                      <span className="pl-4 font-light">مبلغ {Intl.NumberFormat().format(item.amount)} {item.currency} در تراکنش به شماره حسابداری <span onClick={() => window.open(`${window.location.origin}/transactions/${item.transactionType}/${item.transactionId}`, '_blank')} style={{ cursor: 'pointer', color: '#1062d0' }}>{item.transactionAccountingCode}</span> اختصاص یافته است</span>
                    </div>
                  </>))
              }
            </div>
          </div>
        </div>

        <div
          className={`  sm:  ${!isFooterSmaller ? "hidden" : ""
            }   flex bg-white p-4 rounded-md gap-4 justify-between sticky bottom-0 items-center z-[2] shadow-inner flex-wrap md:flex-nowrap `}
        >
          <div className="flex items-center justify-between gap-8">
            <span className="pl-4 text-lg font-bold border-l border-slate-400">مبلغ قابل پرداخت</span>
            <div className="flex items-center gap-2 px-4">
              <span className="text-lg font-bold">{Intl.NumberFormat().format(totalPrice)}</span>
              <span className="text-sm text-dark-3">{state?.currency?.en_title}</span>
            </div>
          </div>
          {factorData.active.saving && (
            <div className="flex gap-4">
              <div className="flex items-center gap-1">
                <span>
                  {factorData.saved.factor ? (
                    <CheckIcon color="#1062D0" />
                  ) : (
                    <CircularProgress color="info" size={14} />
                  )}
                </span>
                <span>فاکتور</span>
              </div>
              {(isEdit ? state.updateBill : !!factorData.rows.find((x) => x.warehouseId)) && (
                <div className="flex items-center gap-1">
                  <span>
                    {factorData.saved.remittance ? (
                      <CheckIcon color="#1062D0" />
                    ) : (
                      <CircularProgress color="info" size={14} />
                    )}
                  </span>
                  <span>حواله</span>
                </div>
              )}
              <div className="flex items-center gap-1">
                <span>
                  {factorData.saved.transaction ? (
                    <CheckIcon color="#1062D0" />
                  ) : (
                    <CircularProgress color="info" size={14} />
                  )}
                </span>
                <span>تراکنش</span>
              </div>
            </div>
          )}
          <div className="flex gap-4">
            {isEdit ? (
              <>
                {
                  <div className="">
                    <div>
                      <Checkbox
                        checked={state.updateBill}
                        onChange={() => setState((x) => ({ ...x, updateBill: !x.updateBill }))}
                      />
                      <span>به روز رسانی حواله انبار</span>
                    </div>
                  </div>
                }
                {data.status === "پیش نویس" && (
                  <BasicButton
                    disabled={active.saving}
                    variant="outlined"
                    className="w-36 md:w-48"
                    onClick={() => handleSubmit(2)}
                  >
                    ذخیره پیش فاکتور
                  </BasicButton>
                )}
                <BasicButton
                  disabled={active.saving}
                  variant="contained"
                  className="w-36 md:w-48"
                  onClick={() => handleSubmit(1, undefined, "printMode")}
                >
                  ذخیره فاکتور و چاپ فاکتور

                </BasicButton>
                <BasicButton
                  disabled={active.saving}
                  variant="contained"
                  className="w-36 md:w-48"
                  onClick={() => handleSubmit(1, undefined, "newMode")}
                >
                  ذخیره فاکتور و فاکتور جدید
                </BasicButton>
              </>
            ) : (
              <>
                {!(state.settings.warehouse.active || state.transactions.length > 0) && (
                  <BasicButton
                    disabled={active.saving}
                    variant="outlined"
                    className="w-36 md:w-48"
                    onClick={() => handleSubmit(2, props.onSuccess, "printMode")}
                  >
                    ثبت پیش فاکتور
                  </BasicButton>
                )}
                <BasicButton
                  disabled={active.saving}
                  variant="contained"
                  className="w-36 md:w-48"
                  onClick={() => handleSubmit(1, props.onSuccess, "printMode")}
                >
                  ثبت نهایی و چاپ فاکتور
                </BasicButton>
                <BasicButton
                  disabled={active.saving}
                  variant="contained"
                  className="w-36 md:w-48"
                  onClick={() => handleSubmit(1, props.onSuccess, "newMode")}
                >
                  ثبت نهایی و فاکتور جدید
                </BasicButton>
              </>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
}
